import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/src/app/[locale]/experiencias/page.tsx");
